import { mapState } from "vuex";
import ConfirmPurchaseTV360 from "@/pages/TV360/components/confirm-purchase-tv360.vue";
import HomeItem from "@/pages/TV360/components/home-item.vue";
import HistoryItem from "@/pages/TV360/components/history-item.vue";
import ProcessingTV360Dialog from "@/pages/TV360/components/processing-tv360-dialog.vue";
import store from "@/store";
import MetfoneLoading from "@/components/metfone-loading.vue";
import getErrorMessage from "@/helpers/error-server";
import DataNotify from "@/components/data-notify";
import Loading from "@/components/loading";

export default {
  name: "TV360Home",
  components: {
    MetfoneLoading,
    ConfirmPurchaseTV360,
    ProcessingTV360Dialog,
    HomeItem,
    HistoryItem,
    DataNotify,
    Loading,
  },
  data() {
    return {
      item: null,
      showDetail: false,
      showHistoryLoading: false,
      tv360Services: null,
      tv360History: null,
      fullHistory: null,
      historyPage: 1,
      historyPageSize: 20,
      historyFinished: false,
      historyLoading: false,
      historyRefreshing: false,
      historyRefreshProcessing: false,
      historyRequestedLoads: 0,
      loadingService: false,
      itemActive: null,
      showProcessingDialog: false,
      titleProcessingDialog: this.$t("tv360.processing_title"),
      contentProcessingDialog: this.$t("tv360.processing_content"),
    };
  },
  computed: {
    ...mapState("userStore", ["profile", "defaultParam"]),
    ...mapState("routerStore", ["isShowContentTV360", "isShowActiveTabs"]),
  },
  async created() {
    //await this.getListPackage();
  },
  watch: {
    historyRefreshing(value) {
      if (value && !this.historyRefreshProcessing) {
        console.log("[TV360] historyRefreshing watcher triggered");
        this.onRefreshHistory();
      }
    },
    "$route.hash": {
      handler: function (dialog_id) {
        if (dialog_id !== "#confirmpurchasetv360") {
          this.showDetail = false;
          this.itemActive = null;
          store.dispatch("routerStore/setActionModalClose", null);
        }
      },
      immediate: true,
    },
    showDetail(value) {
      if (value == false) {
        // this.item = null;
      }
    },
    defaultParam(value) {
      if (value) this.getListPackage();
    },
    isShowContentTV360: {
      handler(value) {
        // Only react when TV360 tab is active
        if (this.isShowActiveTabs === "tabTV360") {
          if (value === "history") {
            this.historyPage = 1;
            this.historyFinished = false;
            this.fullHistory = null;
            this.getHistoryPackage();
            this.tv360Services = null;
          } else {
            this.getListPackage();
            this.tv360History = null;
          }
        }
      },
      immediate: true,
    },
  },
  methods: {
    checkArray(array) {
      if (Array.isArray(array)) {
        return true;
      } else return false;
    },
    stateAsObject(value) {
      return JSON.parse(JSON.stringify(value));
    },
    isObjectEmpty(obj) {
      return Object.entries(obj).length === 0;
    },

    async handleShowDetail(value) {
      console.log("[TV360]handleShowDetail item", value);
      const defaultParam = this.stateAsObject(this.defaultParam);
      defaultParam.serviceCode = value.serviceCode;

      this.item = value;
      this.itemActive = this.item.serviceCode;
      //this.item.subFullDes = this.item.subFullDes;
      //this.item.subCode = this.item.subCode;

      this.$store.dispatch("routerStore/setActionModalClose", true);
      this.showDetail = true;
      // Chỉ pushState nếu URL chưa có action param (tránh push nhiều lần)
      if (!window.location.hash.includes("action=confirmpurchasetv360")) {
        console.log("[TV360] Pushing confirmpurchasetv360 to URL");
        const newUrl =
          window.location.origin +
          window.location.pathname +
          "#/home?tab=tabTV360&action=confirmpurchasetv360";
        history.pushState(null, "", newUrl);
        history.pushState(null, "", newUrl);
      }
    },
    async getListPackage() {
      if (this.defaultParam) {
        const defaultParam = this.stateAsObject(this.defaultParam);
        defaultParam.groupCode = "METFONE_TV360";
        let params = defaultParam;
        if (this.profile) {
          let tempPhone = this.profile.phone.replace(/\D/g, "");
          params.msisdn = tempPhone;
        }

        try {
          this.loadingService = true;
          const res = await this.$store.dispatch(
            "tv360Store/getListPackage",
            params,
          );
          if (res) {
            let result = res.data;
            if (result && result.errorCode == 0) {
              const groupService = result.groupServices;
              if (Array.isArray(groupService)) {
                this.tv360Services = groupService[0].services;
              } else {
                this.tv360Services = groupService.services;
              }
              console.log("[TV360-Store] tv360Services", this.tv360Services);
            } else {
              this.$store.dispatch("notifyStore/addNotify", {
                code: 1,
                message: getErrorMessage(result.errorCode),
              });
            }
          } else {
            this.$store.dispatch("notifyStore/addNotify", {
              code: 1,
              message: getErrorMessage(500),
            });
          }
        } catch (e) {
          console.log("[TV360-Store] catch e", e);
          this.$store.dispatch("notifyStore/addNotify", {
            code: 1,
            message: getErrorMessage(999),
          });
        } finally {
          this.loadingService = false;
        }
      }
    },
    async getHistoryPackage() {
      if (this.defaultParam) {
        const defaultParam = this.stateAsObject(this.defaultParam);
        let params = defaultParam;
        if (this.profile) {
          //let tempPhone = this.profile.phone.replace(/\D/g, "");
          //params.msisdn = tempPhone;
          params.accountABA = this.profile.appId;
        }

        params.page = params.page || this.historyPage;
        params.pageSize = params.pageSize || this.historyPageSize;
        params.accountABA = this.profile.appId;
        console.log(
          `[TV360] getHistoryPackage page=${params.page} pageSize=${params.pageSize} refreshing=${this.historyRefreshing}`,
        );

        try {
          if (this.historyRefreshing) this.historyLoading = false;
          else this.historyLoading = true;

          const res = await this.$store.dispatch(
            "tv360Store/getHistoryPackageTV360",
            params,
          );

          if (res) {
            let result = res.data;
            if (result && result.errorCode == 0) {
              const services = result.services || [];

              // If server returned pagination info, treat response as paged
              if (
                typeof result.currentPage !== "undefined" ||
                typeof result.totalPages !== "undefined"
              ) {
                if (this.historyPage === 1) {
                  this.tv360History = services;
                } else {
                  this.tv360History = (this.tv360History || []).concat(
                    services,
                  );
                }

                const total =
                  result.totalPages ||
                  Math.ceil((result.totalItems || 0) / this.historyPageSize);
                if (total > 0) {
                  this.historyFinished = this.historyPage >= total;
                } else {
                  // fallback: if returned less than a full page, assume finished
                  this.historyFinished = services.length < this.historyPageSize;
                }
              } else {
                // server returned full list: paginate client-side
                if (this.historyPage === 1 || !this.fullHistory) {
                  this.fullHistory = services;
                  this.tv360History = services.slice(
                    0,
                    this.historyPage * this.historyPageSize,
                  );
                } else {
                  this.fullHistory = this.fullHistory || services;
                  const start = (this.historyPage - 1) * this.historyPageSize;
                  const nextItems = this.fullHistory.slice(
                    start,
                    start + this.historyPageSize,
                  );
                  this.tv360History = (this.tv360History || []).concat(
                    nextItems,
                  );
                }

                this.historyFinished =
                  (this.tv360History || []).length >=
                  (this.fullHistory || []).length;
              }

              console.log("[TV360] tv360History loaded", this.tv360History);
            } else {
              this.$store.dispatch("notifyStore/addNotify", {
                code: 1,
                message: getErrorMessage(result.errorCode),
              });
            }
          } else {
            this.$store.dispatch("notifyStore/addNotify", {
              code: 1,
              message: getErrorMessage(500),
            });
          }
        } catch (e) {
          console.log("[TV360-Store] catch e", e);
          this.$store.dispatch("notifyStore/addNotify", {
            code: 1,
            message: getErrorMessage(999),
          });
        } finally {
          console.log(
            "[TV360] getHistoryPackage finally — flags before clear",
            {
              historyLoading: this.historyLoading,
              historyRefreshing: this.historyRefreshing,
              historyRequestedLoads: this.historyRequestedLoads,
              historyPage: this.historyPage,
            },
          );
          this.historyLoading = false;
          this.historyRefreshing = false;
          this.loadingService = false;
          if (this.historyRequestedLoads > 0) {
            this.historyRequestedLoads = Math.max(
              0,
              this.historyRequestedLoads - 1,
            );
            console.log(
              "[TV360] processing 1 queued load after previous finished — loading next page",
              {
                page: this.historyPage + 1,
                remainingQueued: this.historyRequestedLoads,
              },
            );
            this.historyPage += 1;

            setTimeout(async () => {
              console.log(
                "[TV360] scheduled queued load firing — calling getHistoryPackage",
                { page: this.historyPage },
              );
              await this.getHistoryPackage();
              console.log("[TV360] scheduled queued load finished", {
                historyPage: this.historyPage,
                historyFinished: this.historyFinished,
                remainingQueued: this.historyRequestedLoads,
              });
            }, 50);
          }
        }
      }
    },

    //=============================================================================
    onTouchStart(e) {
      try {
        this._tv360_touch_start =
          e.touches && e.touches[0] ? e.touches[0].clientY : 0;
        this._tv360_touch_current = this._tv360_touch_start;
        this._tv360_touch_delta = 0;
      } catch (err) {
        this._tv360_touch_start = 0;
        this._tv360_touch_current = 0;
        this._tv360_touch_delta = 0;
      }
    },
    onTouchMove(e) {
      if (!e.touches || !e.touches[0]) return;
      this._tv360_touch_current = e.touches[0].clientY;
      this._tv360_touch_delta =
        this._tv360_touch_current - (this._tv360_touch_start || 0);
    },
    onTouchEnd() {
      const delta = this._tv360_touch_delta || 0;
      // Only trigger if pulled down enough and page is scrolled to top
      if (
        delta > 60 &&
        (window.pageYOffset || document.documentElement.scrollTop) <= 0
      ) {
        console.log("[TV360] fallback touch refresh triggered", { delta });
        // Call refresh handler if not already refreshing
        if (!this.historyRefreshing && !this.historyRefreshProcessing) {
          this.onRefreshHistory();
        }
      }
      this._tv360_touch_start = 0;
      this._tv360_touch_current = 0;
      this._tv360_touch_delta = 0;
    },

    async onLoadMoreHistory() {
      console.log("[TV360] onLoadMoreHistory");
      const currentCount = (this.tv360History || []).length;
      if (currentCount < this.historyPageSize) {
        return;
      }

      this.historyPage += 1;
      await this.getHistoryPackage();
    },

    async onRefreshHistory() {
      console.log("[TV360] onRefreshHistory");
      if (this.historyRefreshProcessing) return;
      this.historyRefreshProcessing = true;
      try {
        this.historyPage = 1;
        this.historyRefreshing = true;
        this.historyFinished = false;
        this.fullHistory = null;
        await this.getHistoryPackage();
      } finally {
        this.historyRefreshProcessing = false;
      }
    },

    async onSyncHistory(item) {
      //TODO: Hoai dev here
      let isDev = false;
      if (isDev) {
        console.log("[TV360] onSyncHistory called with item", item);

        this.contentProcessingDialog = this.$t("tv360.processing_message_sync");
        this.showProcessingDialog = true;
        if (!window.location.hash.includes("dialog=historysync")) {
          const newUrl =
            window.location.origin +
            window.location.pathname +
            "#/home?tab=tabTV360&dialog=historysync";
          history.pushState(null, "", newUrl);
        }
        return;
      }

      console.log("[TV360] onSyncHistory called", item);
      this.showHistoryLoading = true;

      try {
        const requestId =
          item &&
          (item.requestId || item.requestID || item.request_id || item.request);

        let defaultParam = this.stateAsObject(this.defaultParam);
        defaultParam.requestId = requestId;
        defaultParam.accountABA = this.profile.appId;
        let params = defaultParam;
        const res = await this.$store.dispatch(
          "tv360Store/syncTransT360",
          params,
        );

        // Treat errorCode === 0 as success
        if (res && res.data && res.data.errorCode === 0) {
          await this.onRefreshHistory();
        } else {
          this.contentProcessingDialog =
            res.data.message || this.$t("tv360.processing_message_sync");
          this.showProcessingDialog = true;
          if (!window.location.hash.includes("dialog=historysync")) {
            const newUrl =
              window.location.origin +
              window.location.pathname +
              "#/home?tab=tabTV360&dialog=historysync";
            history.pushState(null, "", newUrl);
          }
        }
      } catch (e) {
        console.error("[TV360] onSyncHistory error", e);
        this.contentProcessingDialog = this.$t("tv360.processing_message_sync");
        this.showProcessingDialog = true;
        if (!window.location.hash.includes("dialog=historysync")) {
          const newUrl =
            window.location.origin +
            window.location.pathname +
            "#/home?tab=tabTV360&dialog=historysync";
          history.pushState(null, "", newUrl);
        }
      } finally {
        // hide the top-level loading indicator regardless
        this.showHistoryLoading = false;
      }
    },

    async handleCloseProcessingDialog() {
      if (window.location.hash.includes("dialog=historysync")) {
        history.back();
        window.__ignoreActionClose = true;
      } else {
        this.showProcessingDialog = false;
      }
      //await this.onRefreshHistory();
    },
  },

  async mounted() {
    this.handlePopState = () => {
      const hash = window.location.hash;
      console.log(
        "[popstate] tv360/home/index",
        this.showProcessingDialog,
        hash,
      );
      // Nếu đang ở dialog processing và URL không còn dialog param → đóng dialog processing
      if (this.showProcessingDialog) {
        this.showProcessingDialog = false;
        return;
      }
      this.itemActive = null;

      //return;
    };
    window.addEventListener("popstate", this.handlePopState);
  },
  beforeUnmount() {
    if (this.handlePopState) {
      window.removeEventListener("popstate", this.handlePopState);
    }
  },
};
